<script>
import handyUploader from 'handy-uploader/src/components/handyUploader';
import LoginComponent from '@/components/Auth/Login';
import SignupComponent from '@/components/Auth/Signup';
const uuid = require('uuid');
import {
  getStorage,
  ref,
  uploadString,
  getDownloadURL,
  serverTimestamp,
} from 'firebase/storage';
import { collection, getDocs, getFirestore } from 'firebase/firestore';

export default {
  data() {
    // this.fullDay = false;
    //     }
    //     this.startDateText = startDate.toLocaleDateString('en-UK', {
    //       day: 'numeric',
    //       month: 'short',
    //       year: 'numeric',
    //     });
    //     this.endTS = endDate;
    //     this.startTS = startDate;
    //     this.endDateText = endDate.toLocaleDateString('en-UK', {
    //       month: 'short',
    //       day: 'numeric',
    //       year: 'numeric',
    //     });
    //   } else if (newDates.length === 0 || newDates.length === 1) {
    //     this.dateRange = '';
    //     this.startDateText = '';
    //     this.endDateText = '';
    return {
      cityResidence: '',
      cityUse: '',
      suburbResidence: '',
      suburbUse: '',
      postalCodeResidence: '',
      postalCodeUse: '',
      group_count: 0,
      fullDay: Boolean,
      startDateText: '',
      endDateText: '',
      startDate: '',
      endTS: new Date(),
      startTS: new Date(),
      endDate: '',
      dateRange: '',
      handyAttachments: [],
      successDialog: false,
      rules: {
        required: (value) => !!value || 'Required.',
        min: (v) => v.length >= 8 || 'Be more descriptive.',
        emailMatch: () => "The email and password you entered don't match",
      },
      welcomeDialog: false,
      shouldRedirect: false,
      allCategories: [
        'Technology',
        'Transportation',
        'Household living',
        'DIY',
        'Exercise',
        'Music and Audio',
        'Drones',
        'Events',
        'Holiday and travel',
        'Sports',
        'Film and photography',
      ],
      loginDialog: false,
      signupDialog: false,
      showLoadingForSubmitRequest: false,
      continueAddRequestAfterLogin: false,
      totalFee: 0,
      status: 'active',
      created_by: '',
      userId: '',
      dates: [],
      showPicker: true,
      deposit: '',
      delivery: false,
      name: '',
      description: '',
      category: [],
      days: 1,
      images: [],
      area: '',
      areaOfUse: '',
      location: '',
      selected: '',
      groups: [],
      selectedGroups: [],
    };
  },

  async created() {
    const groups = [];
    const db = getFirestore();
    const groupSnapshot = await getDocs(collection(db, 'groups'));
    groupSnapshot.forEach((doc) => {
      var b = doc.data();
      b.id = doc.id;
      groups.push(b);
    });
    this.groups = groups;

    //add checked: false, disabled: false to each group
    this.groups.forEach((group) => {
      group.checked = false;
      group.disabled = false;
    });
  },
  watch: {
    group_count: function (n, o) {
      if (this.group_count > 4) {
        for (let i = 0; i < this.groups.length; i++) {
          if (!this.groups[i].checked) {
            this.groups[i].disabled = true;
          } else {
            this.groups[i].disabled = false;
          }
        }
      } else {
        for (let i = 0; i < this.groups.length; i++) {
          this.groups[i].disabled = false;
        }
      }
    },
  },
  components: {
    handyUploader,
    LoginComponent,
    SignupComponent,
  },
  methods: {
    initMarkerResidence(loc) {
      console.log('location: ', loc);
      for (let i = 0; i < loc.address_components.length; i++) {
        if (loc.address_components[i].types[0] === 'locality') {
          this.cityResidence = loc.address_components[i].long_name;
        }
        if (loc.address_components[i].types[0] === 'postal_code') {
          this.postalCodeResidence = loc.address_components[i].long_name;
        }
        if (
          loc.address_components[i].types[0] === 'sublocality_level_2' ||
          loc.address_components[i].types[0] === 'sublocality_level_1' ||
          loc.address_components[i].types[0] === 'sublocality'
        ) {
          this.suburbResidence = loc.address_components[i].long_name;
        }
      }
    },
    initMarkerUse(loc) {
      console.log('location: ', loc);
      for (let i = 0; i < loc.address_components.length; i++) {
        if (loc.address_components[i].types[0] === 'locality') {
          this.cityUse = loc.address_components[i].long_name;
        }
        if (loc.address_components[i].types[0] === 'postal_code') {
          this.postalCodeUse = loc.address_components[i].long_name;
        }
        if (
          loc.address_components[i].types[0] === 'sublocality_level_2' ||
          loc.address_components[i].types[0] === 'sublocality_level_1' ||
          loc.address_components[i].types[0] === 'sublocality'
        ) {
          this.suburbUse = loc.address_components[i].long_name;
        }
      }
    },
    dashboard() {
      this.$router.push('/dashboard');
    },
    items() {
      this.$router.push('/search');
    },
    group_increase: function (group) {
      //changing the value of checked to add the blue class, with this class I add
      // the background color to the button as if it was active.
      group.checked = !group.checked;

      if (group.checked) {
        this.group_count++;
      } else {
        this.group_count--;
        ``;
      }
    },
    async uploadFiles() {
      return new Promise(async (resolve, reject) => {
        var photos = [];

        const storage = getStorage();
        // const db = getFirestore();
        // const storagePromises = [];
        const fileNames = [];

        for (let i = 0; i < this.handyAttachments.length; i++) {
          const file = this.handyAttachments[i].file.base64;

          // console.log(file);
          const fileName = `${Date.now()}_${
            this.handyAttachments[i].file.name
          }`;
          console.log(fileName);
          fileNames.push(fileName);

          const storageRef = ref(storage, `items/userID/itemName/${fileName}`);

          console.log(storageRef);

          const snapshot = await uploadString(storageRef, file, 'base64');
          const downloadURL = await getDownloadURL(snapshot.ref);

          photos.push({ src: downloadURL });

          console.log(downloadURL);
        }

        resolve(photos);
      });
    },

    async submitRequest() {
      if (!this.userIsAuthenticated()) {
        // TODO
        this.loginDialog = true;
        this.continueAddRequestAfterLogin = true;
      } else {
        this.showLoadingForSubmitRequest = true;
        var images = await this.uploadFiles();
        const requestData = {
          name: this.name,
          created_by: this.$store.getters.user.name.split(' ')[0],
          userID: this.$store.getters.user.id,
          createdAt: new Date(),
          description: this.description,
          category: this.category,
          area: this.area,
          areaOfUse: this.areaOfUse,
          location: this.location,
          community: this.category,
          area: this.suburbResidence,
          areaOfUse: this.suburbUse,
          city: this.cityResidence,
          cityOfUse: this.cityUse,
          location: this.postalCodeResidence,
          locationOfUse: this.postalCodeUse,
          images: images,
          delivery: this.delivery,
          totalFee: this.totalFee,
          dateRange: this.dateRange,
          startDateText: this.startDateText,
          endDateText: this.endDateText,
          endDateTS: this.endTS,
          startDateTS: this.startTS,
        };

        this.dialog = true;
        this.$store
          .dispatch('requests/createRequest', requestData)
          .then(() => {
            this.showLoadingForSubmitRequest = false;
            this.successDialog = true;
          })
          .catch((err) => {
            //handle error
            console.log(err);
            this.showLoadingForSubmitRequest = false;
          });
        // this.$confetti.start();
      }
    },

    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
    userIsLogged() {
      if (!this.userIsAuthenticated) {
        return false;
      } else if (this.userIsAuthenticated) {
        return true;
      }
    },
    userIsNotAuthenticated() {
      return (
        this.$store.getters.user == null &&
        this.$store.getters.user == undefined
      );
    },

    async remove() {
      this.uploaded > 0 ? this.uploaded-- : (this.uploaded = 0);
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  computed: {
    // groups() {
    //   return this.$store.state.groups.groups;
    // },
    error() {
      return this.$store.getters.error;
    },
    user() {
      return this.$store.getters.user;
    },
    nameProgress() {
      return Math.min(100, this.name.length * 10);
    },
    nameColor() {
      return ['error', 'warning', 'success'][
        Math.floor(this.nameProgress / 30)
      ];
    },
    loading() {
      return this.$store.getters.loading;
    },
    progress() {
      return Math.min(100, this.description.length * 1.6);
    },
    color() {
      return ['red', 'orange', 'green'][Math.floor(this.progress / 40)];
    },
    formIsValid() {
      return this.name.length > 5;
    },
  },

  watch: {
    dates(newDates) {
      if (newDates.length >= 1) {
        //set the startDate to be the earliest date in the array
        var startDate = new Date(newDates[0]);
        if (newDates.length === 1) {
          var endDate = new Date(newDates[0]);
        } else {
          var endDate = new Date(newDates[1]);
        }
        //change startDate to be the earliest date in the newDates array
        if (startDate > endDate) {
          startDate = new Date(newDates[1]);
          endDate = new Date(newDates[0]);
        }
        // const startDate = new Date(newDates[0]);
        // const endDate = new Date(newDates[1]);
        const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        this.difDays = diffDays;

        if (diffDays == 0) {
          this.fullDay = true;
          this.dateRange = 1;
        } else {
          this.dateRange = diffDays;
          this.fullDay = false;
        }
        this.startDateText = startDate.toLocaleDateString('en-UK', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        });
        this.endTS = endDate;
        this.startTS = startDate;
        this.endDateText = endDate.toLocaleDateString('en-UK', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        });
      } else if (newDates.length === 0 || newDates.length === 1) {
        this.dateRange = '';
        this.startDateText = '';
        this.endDateText = '';
      }
    },
  },
};
</script>

<template>
  <div class="d-flex justify-center">
    <v-row style="max-width: 1700px">
      <v-col cols="10" offset="1">
        <v-card color="#F7F7F7" class="pa-3 my-9 px-md-16 py-7 round">
          <p class="text-h4 text-center app--text">New Request</p>
          Name of Item you are looking for:
          <v-text-field
            v-model="name"
            label="Request Title"
            solo
            class="round"
            hint="More than 6 characters"
            persistent-hint
            counter
            name="name"
            placeholder="Start typing..."
          >
          </v-text-field>
          Category:
          <v-select
            v-model="category"
            solo
            :items="allCategories"
            label="Select the most applicable catagory"
            class="round"
            color="rgb(34, 34, 34)"
          />

          Description:
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-textarea
                v-bind="attrs"
                v-on="on"
                v-model="description"
                placeholder="Start typing..."
                loading
                color="rgb(34, 34, 34)"
                type="text"
                maxlength="250"
                required
                solo
                hint="between 50 and 500 characters."
                counter
                class="round"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    style="border-radius: 12px"
                    :description="progress"
                    :color="color"
                    :value="progress"
                    absolute
                    height="7"
                  />
                </template>
                <template v-slot:label>
                  <div>Describe what you are looking for</div>
                </template>
              </v-textarea>
            </template>
            <span>Minimum of 50 characters needed</span>
          </v-tooltip>

          <v-row>
            <v-col>
              Pictures of what you are looking for? (Optional, Max 5):
              <handy-uploader
                ref="uploader"
                :documentAttachment.sync="handyAttachments"
                :fileUploaderType="'simple'"
                :maxFileSize="10240"
                :imageCompressor="true"
                :imageCompressLevel="0.8"
                :maxFileCount="6"
                :badgeCounter="true"
                :thumb="true"
                :changeFileName="true"
                :addFileDescription="true"
                :addFileTag="true"
                :tags="['Tag 1', 'Tag 2', 'Tag 3', 'Tag 4']"
                :btnColor="'#f8b58e'"
                :fontColor="'#FFFF'"
                :cardType="'raised'"
                class="my-10"
              >
              </handy-uploader>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="6" lg="4">
              When will you be needing the item?
              <v-dialog
                v-if="showPicker === true"
                class="round white"
                color="primary"
                ref="menu"
                v-model="menu"
                :return-value.sync="dates"
                persistent
                transition="scale-transition"
                offset-y
                width="290"
                rounded
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dates"
                    label="Select date range"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dates"
                  elevation="12"
                  class="round"
                  :min="new Date().toISOString().substr(0, 10)"
                  range
                  persistent
                  no-title
                  scrollable
                >
                  <!-- <v-spacer></v-spacer> -->
                  <v-col class="mt-n3">
                    <div class="text-center mt-4" v-if="dates.length >= 1">
                      <p>{{ dateRange }} day(s) selected</p>
                    </div>

                    <!-- <v-spacer></v-spacer> -->
                    <v-row>
                      <v-btn
                        text
                        color="primary"
                        @click.prevent="clearSelection"
                      >
                        Clear
                      </v-btn>
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(dates)"
                      >
                        OK
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-date-picker>
              </v-dialog>
              <!-- <v-text-field
              v-model="days"
              label="0"
              required
              suffix="Days"
              v-on:keypress="isNumber(event)"
              class="round"
              solo
            /> -->
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4">
              How much are you willing to pay per day for the item?
              <v-text-field
                v-model="totalFee"
                label="0"
                required
                prefix="R"
                v-on:keypress="isNumber(event)"
                class="round"
                solo
              />
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4">
              Will you need the item delivered?
              <v-switch
                v-model="delivery"
                solo
                inset
                true-value="yes"
                false-value="no"
                :label="`${delivery.toString()}`"
                class="round"
                color="rgb(34, 34, 34)"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="6" lg="4">
              Suburb of Residence:
              <!-- <v-text-field
                v-model="area"
                solo
                prepend-icon="mdi-map-marker"
                ref="autocomplete"
                class="round"
                label="Suburb"
                required
              /> -->
              <gmap-autocomplete
                class="gmap"
                @place_changed="initMarkerResidence"
              ></gmap-autocomplete>
            </v-col>

            <!-- <v-col cols="12" sm="12" md="6" lg="4">
              Postal Code:
              <v-text-field
                v-model="location"
                solo
                ref="autocomplete"
                class="round"
                label="Postal Code"
                required
              />

            </v-col> -->

            <v-col cols="12" sm="12" md="6" lg="4">
              Suburb of Use:
              <!-- <v-text-field
                v-model="areaOfUse"
                solo
                prepend-icon="mdi-map-marker"
                ref="autocomplete"
                class="round"
                label="Suburb"
                required
              /> -->
              <gmap-autocomplete
                class="gmap"
                @place_changed="initMarkerUse"
              ></gmap-autocomplete>
            </v-col>
          </v-row>
          <!--
          <v-row> Add your requests to a community? </v-row>

          <v-row>
            <div class="interests__content text-left">
              <transition-group>
                <v-tooltip
                  color="#AB47BC"
                  top
                  v-for="group in groups"
                  :key="group.name"
                >
                  <template v-slot:activator="{ props }">
                    <v-btn
                      v-model="selected"
                      v-bind="props"
                      outlined
                      style="border-radius: 8px"
                      slot="activator"
                      :class="{
                        material: group.checked,
                        interest__btn: !group.checked,
                      }"
                      class="ma-1"
                      @click="group_increase(group)"
                      :disabled="group.disabled"
                      :checked="checked"
                      >{{ group.name }}</v-btn
                    >
                  </template>
                </v-tooltip>
              </transition-group>
            </div>
          </v-row> -->

          <v-btn
            @click="submitRequest()"
            class="ebtn mt-8"
            :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
            type="submit"
            rounded
            color="accent"
            elevation="8"
            :loading="showLoadingForSubmitRequest"
          >
            Submit
          </v-btn>
        </v-card>
      </v-col>

      <v-dialog
        v-model="successDialog"
        max-width="450px"
        persistent
        transition="dialog-bottom-transition"
      >
        <template>
          <v-card style="border-radius: 12px !important" class="text-center">
            <v-card-title
              style="
                padding: 0px 24px !important;
                font-size: 1em !important;
                line-height: 1.43;
              "
              class="text-center black--text"
            >
              <p class="my-3 ml-auto mr-auto">Woohoo!</p>
            </v-card-title>
            <v-divider></v-divider>
            <div class="grid">
              <v-img
                size="small"
                width="300px"
                height="300px"
                :src="require('@/assets/svgs/celebrate-1.svg')"
              ></v-img>
            </div>
            <v-card-text
              style="
                font-size: 16px !important;
                line-height: 20px !important;
                color: rgb(34, 34, 34) !important;
              "
              class="my-5"
            >
              We have recieved your Item request. Keep out for any updates from
              us!
            </v-card-text>

            <v-card-actions class="mt-n9">
              <v-col>
                <v-row class="mb-3">
                  <v-btn
                    block
                    class="btn white--text"
                    style="border-radius: 8px !important"
                    @click="dashboard()"
                    color="black"
                  >
                    Continue to dashboard
                  </v-btn>
                </v-row>
                <v-row>
                  <v-btn
                    block
                    class="mt-1 btn white--text"
                    style="border-radius: 8px !important"
                    @click="items()"
                    color="accent"
                  >
                    Browse available items
                  </v-btn>
                </v-row>
              </v-col>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

      <v-overlay v-if="showLoadingForSubmitRequest">
        <v-img :src="require('@/assets/svgs/gondola2.svg')" />
        Uploading your request...
      </v-overlay>
    </v-row>
  </div>
</template>

<style scoped>
.round {
  border-radius: 12px;
}

.dropzone .dz-preview.dz-image-preview {
  background: white;
  z-index: 2;
}

.gmap {
  background-color: white;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  width: 100%;
}
</style>
